import Load from 'components/Load';
import PrivateRoute from 'components/PrivateRoute';
import React from 'react';
import basePath from 'utils/basePath';

const AsyncReviewPageContainer = Load(
  () =>
    import(
      /* webpackChunkName: "review-page" */ './containers/ReviewPageContainer'
    ),
);

const ReviewPageRoute = [
  <PrivateRoute
    key="host-review-page"
    path={`${basePath}/host/review/:reviewId`}
    component={AsyncReviewPageContainer}
  />,
];

export default ReviewPageRoute;
